import * as React from "react";
import { DayPicker } from "react-day-picker";
import { cn } from "@/lib/utils";

export type CalendarProps = React.ComponentProps<typeof DayPicker>;

export function Calendar({
  className,
  classNames,
  showOutsideDays = true,
  components,
  ...props
}: CalendarProps) {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={cn("p-3 w-full", className)}
      classNames={{
        // ✅ make the calendar take full width
        months: "w-full flex flex-col sm:flex-row gap-4",
        month: "w-full space-y-4",

        caption: "flex items-center justify-center relative",
        caption_label: "text-sm font-medium",

        caption_dropdowns: "flex items-center gap-2",
        dropdown: cn(
          "h-9 rounded-md border border-border bg-background px-2 text-sm",
          "focus:outline-none focus:ring-2 focus:ring-ring"
        ),

        nav: "flex items-center gap-1",
        nav_button:
          "h-8 w-8 rounded-md border border-border bg-background/50 hover:bg-muted/40 transition grid place-items-center",
        nav_button_previous: "absolute left-1",
        nav_button_next: "absolute right-1",

        // ✅ KEY FIX: grid layout so it stretches to container width
        table: "w-full border-collapse",
        head_row: "grid grid-cols-7 w-full",
        head_cell: "w-full text-center text-muted-foreground font-normal text-[0.8rem] py-1",

        row: "grid grid-cols-7 w-full mt-2",
        cell: "p-0 text-center text-sm",

        // ✅ each day fills the cell (no more w-9)
        day: "h-10 w-full rounded-md hover:bg-muted/40 transition",
        day_selected: "bg-primary text-primary-foreground hover:bg-primary/90",
        day_today: "text-muted-foreground",
        day_outside: "text-muted-foreground opacity-50",
        day_disabled: "text-muted-foreground opacity-40",
        day_hidden: "invisible",

        ...classNames,
      }}
      components={{
        ...components, // keep your custom caption support
      }}
      {...props}
    />
  );
}

Calendar.displayName = "Calendar";